import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ControlesComponent } from './controles/controles.component';

const routes: Routes = [{ path: '', component: ControlesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ControlesRoutingModule {}
